import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { catchError, switchMap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable()
export class RequestsHandlerInterceptor implements HttpInterceptor {
  /** Endpoints that often return 401 for guests — never try token refresh */
  private readonly guestOkUrls = [
    'get-user-info',
    'wishlist',
    'is-authenticated',
    '/auth/me',
  ];

  private readonly noTokenRequests = [
    'login',
    'signup',
    'logout',
    'refresh-token',
    'verify-2fa-code',
    'send-password-reset-token',
    'check-password-reset-token',
    'reset-password',
  ];

  constructor(
    private AuthService: AuthService,
    private loader: NgxUiLoaderService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const authReq = req.clone({
      withCredentials: true,
      setHeaders: {
        'Content-Lang': 'ar',
      },
    });

    if (this.noTokenRequests.some((url) => req.url.includes(url))) {
      return next.handle(authReq);
    }

    // Guest-safe calls: pass 401 through without refresh (avoids 404 refresh-token spam)
    if (this.guestOkUrls.some((url) => req.url.includes(url))) {
      return next.handle(authReq);
    }

    return next.handle(authReq).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status !== 401) {
          return throwError(() => err);
        }

        return this.AuthService.refreshToken().pipe(
          switchMap(() => next.handle(authReq.clone())),
          catchError(() => {
            this.loader.stop();
            return throwError(() => err);
          })
        );
      })
    );
  }
}
